// extracted by mini-css-extract-plugin
export default {"scoreDisplay":"ScoreDisplay_scoreDisplay__XgCxI","grow":"ScoreDisplay_grow__lHvq6"};